import countries from '../constants/countries';
import moment from 'moment';

export const fullCountryName = (code) => {
  const filteredCountry = countries.filter(country => {
    return country.code === code;
  });

  return filteredCountry[0].name;
};

export const prepareLastActiveText = (lastActive) => {
  if(!!lastActive) {
    const now = moment();
    lastActive = moment(lastActive);
    if(now.diff(lastActive, 'hours') > 24 && now.diff(lastActive, 'hours') < 120) {
      return `active about ${now.diff(lastActive, 'days')} days ago`;
    } else if(now.diff(lastActive, 'hours') >= 120) {
      return `active about ${Math.floor(Math.random() * 5) + 1} days ago`;
    } else if(now.diff(lastActive, 'hours') <= 24) {
      return `active about ${now.diff(lastActive, 'hours')} hours ago`;
    }
  }
  return `active about ${Math.floor(Math.random() * 5) + 1} days ago`;
};

export const productName = (key) => {
  const names = {
    '1_magnet': '1 Magnet for 24 hours',
    '5_magnet': '5 x 1 Magnet for 24 hours',
    'superior_membership': '1 month premium',
    '3_superior_membership': '3 months premium',
    'host-date': '',
    'PROMO': 'Free Promo Trial',
  };

  return names[key];
};


// WEBPACK FOOTER //
// ./src/helpers/functions.js